import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "./../../../assets/images/logo.png";
import NetworkStatus from "../../../utils/networkStatus";
import "./headerdashboard.scss";
import "../sidebar/skeleton.css";
import { INVOICE } from "../../../route/paths";
import HeaderDashboardWithProfile from "./HeaderDashboardWithProfile";
import { useDispatch, useSelector } from "react-redux";
import { validateUser } from "../../../redux/authSlice";

const HeaderDashboard = (props) => {
  const { authUser, isAfterValidated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAfterValidated) {
      dispatch(validateUser());
    }
  }, [dispatch, isAfterValidated]);

  if (!authUser) {
    return (
      <>
        <div className="home-header">
          <div className="container">
            <div className="home-header-wrap d-flex justify-content-between align-items-center">
              <div className="logo">
                <Link to={INVOICE}>
                  <img src={Logo} alt="logo" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="blank-height" />
        <NetworkStatus />
      </>
    );
  }

  return <HeaderDashboardWithProfile {...props} />;
};

export default HeaderDashboard;
